var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import mergeRefs from "react-merge-refs";
import { useInputValue } from "../utils/useInputValue";
var useStyles = makeStyles(function (_a) {
    var spacing = _a.spacing, typography = _a.typography;
    return createStyles({
        root: {
            display: "flex",
            justifyContent: "left",
            flexWrap: "wrap",
            padding: spacing(5.5, 4, 1.5),
            width: "100%",
            overflow: "hidden",
            "& > *": {
                margin: spacing(0.5, 1, 0.5, 0),
                maxWidth: "100%",
            },
        },
        inputWrapper: __assign({ flexGrow: 1, position: "relative", overflow: "hidden" }, typography.body1),
        input: {
            padding: 0,
            height: "auto",
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        },
        widthController: {
            visibility: "hidden",
            whiteSpace: "pre",
        },
    });
}, { name: "EuiChipInputComponent" });
export var ChipInputComponent = function (_a) {
    var className = _a.className, inputRef = _a.inputRef, chips = _a.chips, props = __rest(_a, ["className", "inputRef", "chips"]);
    var classes = useStyles();
    var localInputRef = React.useRef(null);
    var _b = useInputValue(props), value = _b.value, onChange = _b.onChange;
    var manageFocus = React.useCallback(function (_a) {
        var target = _a.target, currentTarget = _a.currentTarget;
        return currentTarget.isSameNode(target) &&
            localInputRef.current &&
            localInputRef.current.focus();
    }, []);
    return (
    // eslint-disable-next-line
    React.createElement("div", { className: classes.root, onClick: manageFocus },
        chips,
        React.createElement("div", { className: classes.inputWrapper },
            React.createElement("input", __assign({ className: clsx(className, classes.input) }, props, { onChange: onChange, ref: mergeRefs([localInputRef, inputRef || null]) })),
            React.createElement("span", { "aria-hidden": "true", className: classes.widthController }, value || " "))));
};
//# sourceMappingURL=ChipInputComponent.js.map